import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="animated-phrases"
export default class extends Controller {
  static targets = ["text", "cursor"]
  static values = { phrases: Array }

  connect() {
    this.currentPhraseIndex = 0
    this.currentCharIndex = 0
    this.isDeleting = false
    this.typeSpeed = 100
    this.deleteSpeed = 50
    this.pauseTime = 2000
    
    this.startAnimation()
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  startAnimation() {
    this.animateText()
  }

  animateText() {
    const currentPhrase = this.phrasesValue[this.currentPhraseIndex]
    const textTarget = this.textTarget
    
    if (!this.isDeleting) {
      // Typing
      if (this.currentCharIndex < currentPhrase.length) {
        textTarget.textContent = currentPhrase.substring(0, this.currentCharIndex + 1)
        this.currentCharIndex++
        this.timeout = setTimeout(() => this.animateText(), this.typeSpeed)
      } else {
        // Pause before deleting
        this.timeout = setTimeout(() => {
          this.isDeleting = true
          this.animateText()
        }, this.pauseTime)
      }
    } else {
      // Deleting
      if (this.currentCharIndex > 0) {
        textTarget.textContent = currentPhrase.substring(0, this.currentCharIndex - 1)
        this.currentCharIndex--
        this.timeout = setTimeout(() => this.animateText(), this.deleteSpeed)
      } else {
        // Move to next phrase
        this.isDeleting = false
        this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrasesValue.length
        this.timeout = setTimeout(() => this.animateText(), this.typeSpeed)
      }
    }
  }
}
